__webpack_require__.p = "https://hores.portalcomb.cat/";